//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
 * This page is prepared for CMS dynamic content rendering.
 */
import { useAppState } from "../composables";
import { onMounted, useRouter, nextTick } from "@nuxtjs/composition-api";
import { MIDDLEWARE } from "../helpers/constants";
import analyticsEvents from "~/helpers/analytics/analyticsEvents";
import { userCheckoutStore } from "~/stores/checkout-store";

export default {
  name: "CMSDynamicPage",
  middleware: [
    MIDDLEWARE.IS_RESTICTED_PAGE,
    MIDDLEWARE.IS_AUTHENTICATED,
    MIDDLEWARE.IS_NOT_AUTHENTICATED,
  ],
  setup() {
    // Destructure only the necessary values from the store
    const { isLogout, resetAppState } = useAppState();
    const router = useRouter()
    const checkoutStore = userCheckoutStore();


    onMounted(async () => {
      // Trigger analytics event after data is fetched
      analyticsEvents.pageLoaded();

      // Reset app state if user is logged out
      if (isLogout.value) {
        await resetAppState();
      }

      router.afterEach((from, to) => {
        if ( from.path !== to.path ) {
          nextTick( () => {
            document.body.tabIndex = 0
            document.body.focus()
            document.body.tabIndex = -1
          } )
        }
      })
    });

    return {}
  },
};
